export const SEND_OTP_ENDPOINT = 'sendOtp';
export const VERIFY_OTP_ENDPOINT = 'verifyOtp';
export const RESEND_OTP_ENDPOINT = 'resendOtp';
export const COUNTRY_CODES = [
  { value: '+91', label: 'IND' },
  { value: '+1', label: 'USA/CAN' },
  { value: '+93', label: 'AFG' },
  { value: '+61', label: 'AUS' },
  { value: '+973', label: 'BHR' },
  { value: '+32', label: 'BEL' },
  { value: '+55', label: 'BRA' },
  { value: '+41', label: 'CHE' },
  { value: '+86', label: 'CHN' },
  { value: '+57', label: 'COL' },
  { value: '+45', label: 'DNK' },
  { value: '+49', label: 'DEU' },
  { value: '+20', label: 'EGY' },
  { value: '+34', label: 'ESP' },
  { value: '+33', label: 'FRA' },
  { value: '+44', label: 'GBR' },
  { value: '+852', label: 'HKG' },
  { value: '+36', label: 'HUN' },
  { value: '+62', label: 'IDN' },
  { value: '+98', label: 'IRN' },
  { value: '+964', label: 'IRQ' },
  { value: '+972', label: 'ISR' },
  { value: '+39', label: 'ITA' },
  { value: '+81', label: 'JPN' },
  { value: '+254', label: 'KEN' },
  { value: '+855', label: 'KHM' },
  { value: '+965', label: 'KWT' },
  { value: '+94', label: 'LKA' },
  { value: '+60', label: 'MYS' },
  { value: '+960', label: 'MDV' },
  { value: '+52', label: 'MEX' },
  { value: '+976', label: 'MNG' },
  { value: '+95', label: 'MMR' },
  { value: '+977', label: 'NPL' },
  { value: '+64', label: 'NZL' },
  { value: '+968', label: 'OMN' },
  { value: '+92', label: 'PAK' },
  { value: '+974', label: 'QAT' },
  { value: '+7', label: 'RUS' },
  { value: '+966', label: 'SAU' },
  { value: '+65', label: 'SGP' },
  { value: '+249', label: 'SDN' },
  { value: '+46', label: 'SWE' },
  { value: '+66', label: 'THA' },
  { value: '+90', label: 'TUR' },
  { value: '+380', label: 'UKR' },
  { value: '+971', label: 'UAE' },
  { value: '+263', label: 'ZWE' },
  { value: ' ', label: 'Others' },
];
